module.exports = __webpack_public_path__ + "static/media/nav-arrow-right-blue.aa69e02b.svg";